/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import lifecycle_codeImg from 'assets/images/lifecycle_code.jpg'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Жизненный цикл компонента</h2>
    <p className={styles.description}>
      Существует несколько стадий жизненного цикла, каждый из которых вызывает для компонента методы наследуемые от
      <code className={styles.code}>React.Component</code>. Мы можем переопределить их поведение добавив необходимый
      функционал, в рамках установленных правил.{' '}
    </p>
    <a
      className={styles.link}
      href="https://projects.wojtekmaj.pl/react-lifecycle-methods-diagram/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Интерактивная диаграмма жизненного цикла
    </a>
    <p className={styles.description}>Интерактивный пример с визуализированными вызовами методов жизненного цикла. </p>
    <iframe
      height="300"
      scrolling="no"
      title="rotman_react_1_1"
      src="https://codesandbox.io/embed/z4xvzl5mx?fontsize=14"
      frameBorder="no"
      loading="lazy"
      allowTransparency="true"
      allowFullScreen="true"
    />
    <p className={styles.description}>Компонент с объявленными методами жизненного цикла.</p>
    <img className={styles.img} src={lifecycle_codeImg} alt="lifecycle_code" />
  </section>
))
